import {
  LiteRouter,
  Tracker,
  PAGE,
  trackEvent,
} from '@/utils'
import { onDelegate } from '@/utils/action-lib'
import $ from 'zepto'
import template from './template'
import { once } from 'lodash'

// cookie隐私弹窗
const runCookie = once(() => {
  if (window.__INIT_STATE__.switcher.cookie) {
    import('@didi/adv-ui/adv-cookie-notice')
      .then(({ defineCustomElement }) => {
        defineCustomElement()
      })
      // cookie加载错误不报错
      .catch(console.log)
  }
})

const Index = {
  template,
  methods: {
    onDelegate() {
      onDelegate(this as unknown as HTMLElement)
    },
    toggleEvent(fn: 'on' | 'off') {
      $('[data-action]')[fn](
        'click',
        Index.methods.onDelegate
      )
    },
  },
  $router: <LiteRouter | null>null,
  mounted($router: LiteRouter) {
    // 上报业务
    trackEvent('fin_loan_abroad_outcast_h5_landing_page_sw')
    // 上报媒体
    Tracker.trackWithMedia(2001)
    // 上报风控
    Tracker.trackWithCache({
      page: PAGE.landing,
    })
    Tracker.trackWithCache({
      page: PAGE.landing,
      sw: 1,
    })
    this.$router = $router
    Index.methods.toggleEvent('on')
    // cookie隐私弹窗
    runCookie()
  },
  destroyed() {
    Index.methods.toggleEvent('off')
  },
}
export default Index
